module.exports = __webpack_public_path__ + "media/recoger_y_sembrar_nuevo.abc925bf.mp4";